import Backbone from 'backbone';

import template from './keywordVNext.pug';

export class KeywordContextualAttributeViewVNext extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
    isMCC,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.isMCC = isMCC;
    this.keywordId = targetId;
    this.keywordQualityScore = '';
  }


  render({
    showDeliveryStatusPopup,
    recommendationAccountId,
  }) {
    const {
      deps,
      keywordId,
    } = this;
    const options = this.isMCC ?
      {
        entitySet:
          deps
            .edmCampaign
            .currentCustomer
            .Accounts
            .$withKey(Number(recommendationAccountId))
            .Keywords,
      } : {};

    deps.jsdata.Keyword.findAll({
      limit: 1,
      select: ['Id', 'QualityScore'],
      where: { Id: { $eq: keywordId } },
    }, options).then((response) => {
      if (response.length && response.length > 0) {
        const qualityScore = response[0].QualityScore ?
          response[0].QualityScore.OverallQualityScore : null;
        this.keywordQualityScore = this.i18n.getString('Keyword_Quality_Score', {
          keywordQualityScore: qualityScore ?
            this.i18n.getString('Keyword_Quality_Score_Value', { keywordQualityScore: qualityScore }) : // eslint-disable-line
            this.i18n.getString('Contextual_Response_Null'),
        });
        this.$el.html(template({ keywordQualityScore: this.keywordQualityScore }));

        showDeliveryStatusPopup(this.el.outerHTML);
      }
    });
    return this;
  }
}
